import { useEffect, useRef } from 'react'

import { useSelector } from 'react-redux'

import { selectDeviceContext, selectDeviceRequestKey } from 'src/store/apps/Common'



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */

export function useDeviceScopedInit(initFn) {

  const deviceUser = useSelector(state => state.Common.deviceUser)

  const context = useSelector(selectDeviceContext)

  const requestKey = useSelector(selectDeviceRequestKey)

  const contextRef = useRef(context)

  contextRef.current = context
  const effectiveDeviceUser = deviceUser || context?.accountId || context?.username



  useEffect(() => {

    if (!effectiveDeviceUser) return



    const controller = new AbortController()

    let active = true

    const scopedContext = contextRef.current

    // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果

    const isCurrent = () =>

      active &&

      !controller.signal.aborted &&

      contextRef.current?.requestKey === requestKey



    initFn(effectiveDeviceUser, {

      context: scopedContext,

      signal: controller.signal,

      isCurrent

    })



    return () => {

      active = false

      controller.abort()

    }

  }, [effectiveDeviceUser, initFn, requestKey])

}

